import { render, staticRenderFns } from "./anchorButton.vue?vue&type=template&id=63bfa3a3"
import script from "./anchorButton.vue?vue&type=script&lang=js"
export * from "./anchorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports